/**
 * The calendar quarter a date falls in (F17).
 *
 * Separate from `QuarterlyReportPage` so that file exports only a component —
 * a module mixing a component and a helper defeats fast refresh, the same rule
 * `stages.ts` and `pilot-status.ts` follow.
 *
 * Calendar quarters (Jan–Mar is Q1): Greenvolt reports on the calendar year,
 * and there is no fiscal-year setting to read today.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 10.3, PRD F17
 */
export function quarterLabel(date: Date): string {
  const quarter = Math.floor(date.getMonth() / 3) + 1;
  return `Q${String(quarter)} ${String(date.getFullYear())}`;
}
